// document.addEventListener("DOMContentLoaded", function () {
//     const buttons = document.querySelectorAll(".tab-button");
//     const products = document.querySelectorAll(".product-item");

//     buttons.forEach(button => {
//       button.addEventListener("click", () => {
//         const filter = button.dataset.filter.toLowerCase().replace(/\s+/g, '-');

//         buttons.forEach(btn => btn.classList.remove("active"));
//         button.classList.add("active");

//         products.forEach(product => {
//           if (filter === "all") {
//             product.style.display = "inline-block";
//           } else {
//             if (product.classList.contains(filter)) {
//               product.style.display = "inline-block";
//             } else {
//               product.style.display = "none";
//             }
//           }
//         });
//       });
//     });
//   }); 


document.addEventListener("DOMContentLoaded", function () {
  const buttons = document.querySelectorAll(".tab-button");
  const products = document.querySelectorAll(".product-item");
  const noProductsMessage = document.getElementById("no-products-message");

  buttons.forEach(button => {
    button.addEventListener("click", () => {
      const filter = button.dataset.filter.toLowerCase().replace(/\s+/g, '-');

      buttons.forEach(btn => btn.classList.remove("active"));
      button.classList.add("active");

      let visibleCount = 0;

      products.forEach(product => {
        if (filter === "all" || product.classList.contains(filter)) {
          product.style.display = "inline-block";
          visibleCount++;
        } else {
          product.style.display = "none";
        }
      });

      // Show or hide the "no products" message
      if (visibleCount === 0) {
        noProductsMessage.style.display = "block";
      } else {
        noProductsMessage.style.display = "none";
      }
    });
  });
});
